import React, { useMemo } from 'react';
import useRules from 'hooks/useRules';

const Total = ({
  total = 0,
  title = 'جمع کل: ',
  backgroundColor = null,
  fontSize = 16,
  endText = 'تومان',
}) => {
  const [rules, hasRule, isAdmin] = useRules();
  const color = useMemo(() => {
    return backgroundColor === 'purple'
      ? '#c5cae9'
      : backgroundColor === 'yellow'
      ? '#f0f4c3'
      : backgroundColor === 'red'
      ? '#f8bbd0'
      : '#a5d6a7';
  }, [backgroundColor]);

  const border = useMemo(() => {
    return backgroundColor === 'purple'
      ? '1px solid rgb(5 0 252 / 31%)'
      : backgroundColor === 'yellow'
      ? '1px solid rgb(141 137 1 / 63%)'
      : backgroundColor === 'red'
      ? '1px solid rgb(154 0 0 / 42%)'
      : '1px solid #1b5e20';
  }, [backgroundColor]);

  return (
    <div
      style={{
        width: '100%',
      }}
    >
      {isAdmin && (
        <div
          style={{
            fontSize,
            padding: '6px 4px',
            borderRadius: '3px',
            border: border,
            backgroundColor: color,
          }}
        >
          <span>{title}: &nbsp;</span>
          <strong>{total}&nbsp;</strong>
          {endText}
        </div>
      )}
    </div>
  );
};

export default Total;
